"use client";

import { useCallback, useRef, useState } from "react";
import type { ChatShareProvider } from "@/src/lib/chat-share/types";
import type { SamplePreviewId } from "@/src/lib/pdf/sample-preview-registry";
import type { EditorWorkspaceHandle } from "../editor-workspace";
import { DeferredEmbeddedConverter } from "../home/deferred-embedded-converter";
import {
  marketingConverterFramingClassName,
  marketingHeadingClassName,
} from "../home/marketing-layout";
import { ChatShareImportToolbar } from "./chat-share-import-toolbar";

export function ShareLinkConverterSection({
  provider,
  heading,
  framing,
  sampleId,
}: Readonly<{
  provider: ChatShareProvider;
  heading: string;
  framing: string;
  sampleId: SamplePreviewId;
}>) {
  const workspaceRef = useRef<EditorWorkspaceHandle | null>(null);
  const [workspaceReady, setWorkspaceReady] = useState(false);
  const [shareUrl, setShareUrl] = useState("");

  const onWorkspaceReadyChange = useCallback((ready: boolean) => {
    setWorkspaceReady(ready);
  }, []);

  return (
    <section
      id="converter"
      data-nosnippet=""
      aria-labelledby="converter-heading"
      className="scroll-mt-20 border-b border-zinc-200 bg-zinc-100 px-4 py-8 md:py-10"
    >
      <div className="mx-auto w-full md:w-[90%]">
        <div className="mb-4">
          <h2 id="converter-heading" className={marketingHeadingClassName}>
            {heading}
          </h2>
          <p className={marketingConverterFramingClassName}>{framing}</p>
        </div>

        <div className="overflow-hidden rounded-lg border border-zinc-200 bg-zinc-100">
          <ChatShareImportToolbar
            provider={provider}
            workspaceRef={workspaceRef}
            workspaceReady={workspaceReady}
            shareUrl={shareUrl}
            onShareUrlChange={setShareUrl}
          />

          <DeferredEmbeddedConverter
            editorSource={provider}
            sampleId={sampleId}
            workspaceRef={workspaceRef}
            onWorkspaceReadyChange={onWorkspaceReadyChange}
            shellClassName="rounded-none border-0"
            chatShareProvider={provider}
            chatShareImportUrl={shareUrl}
          />
        </div>
      </div>
    </section>
  );
}
